/**
 * Cart Component
 *
 * WooCommerce cart page with package selection and checkout.
 * Supports initial cart items from PHP and dynamic add/remove operations.
 *
 * @package Lovasok_Marketplace
 */

import { formatPrice } from '../utils/formatters.js';

export default (initialData = {}) => ({
    // Cart items (from PHP or empty)
    cartItems: initialData.cartItems || [],

    // Available packages (from PHP or fallback)
    packages: initialData.packages || [],

    // Payment method
    paymentMethod: 'card',

    // Coupon
    couponCode: '',
    couponApplied: false,

    init() {
        this.$nextTick(() => document.getElementById('lmk-cart-preload')?.remove());
    },

    // Computed: Subtotal
    get subtotal() {
        return this.cartItems.reduce((sum, item) => sum + (item.price || 0), 0);
    },

    // Computed: Discount
    get discount() {
        return this.couponApplied ? Math.floor(this.subtotal * 0.1) : 0;
    },

    // Computed: Total
    get total() {
        return this.subtotal - this.discount;
    },

    // Add to cart via AJAX
    async addToCart(productId) {
        try {
            const formData = new FormData();
            formData.append('action', 'lovasok_add_to_cart');
            formData.append('product_id', productId);
            formData.append('nonce', lovasokParams.cartNonce);

            const response = await fetch(lovasokParams.ajaxUrl, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                // Reload page to update cart
                window.location.reload();
            } else {
                alert(data.data?.message || 'Hiba történt a kosárba helyezés során.');
            }
        } catch (error) {
            console.error('Error adding to cart:', error);
            alert('Hiba történt a kosárba helyezés során.');
        }
    },

    // Remove from cart via AJAX
    async removeFromCart(cartItemKey) {
        if (!confirm('Biztosan eltávolítod ezt a terméket a kosárból?')) return;

        try {
            const formData = new FormData();
            formData.append('action', 'lovasok_remove_from_cart');
            formData.append('cart_item_key', cartItemKey);
            formData.append('nonce', lovasokParams.cartNonce);

            const response = await fetch(lovasokParams.ajaxUrl, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                // Reload page to update cart
                window.location.reload();
            } else {
                alert(data.data?.message || 'Hiba történt az eltávolítás során.');
            }
        } catch (error) {
            console.error('Error removing from cart:', error);
            alert('Hiba történt az eltávolítás során.');
        }
    },

    // Coupon is handled by the inline Alpine component in cart.php (WC AJAX)
    // This stub is kept so older calls don't throw errors.
    applyCoupon() {},

    // Proceed to checkout
    checkout() {
        if (this.cartItems.length === 0) {
            alert('A kosarad üres!');
            return;
        }

        // Redirect to WooCommerce checkout (use dynamic URL)
        window.location.href = lovasokParams.checkoutUrl;
    },

    // Format price
    formatPrice(price) {
        return formatPrice(price, true);
    }
});
